const formatPrice = function(price, locale, currency = 'USD') {
  const options = {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  };

  return parseFloat(price).toLocaleString(locale, options);
};

export default formatPrice;
